/**
 * Helper function to clean empty HTML content from Jodit editor
 * Jodit often adds <p><br></p> or similar patterns when the field is empty
 * This function detects and removes these patterns to prevent false change detection
 */
export const cleanEmptyHtml = (value: string): string => {
  // Common empty HTML patterns from Jodit editor
  const emptyPatterns = [
    /^<p><br\s*\/?><\/p>$/i,
    /^<p>\s*<\/p>$/i,
    /^<br\s*\/?>$/i,
    /^\s*$/,
  ];

  const trimmedValue = value?.trim() || "";

  // Check if the value matches any empty pattern
  if (emptyPatterns.some((pattern) => pattern.test(trimmedValue))) {
    return "";
  }

  return value;
};
